function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { generateNotificationContentRenderExperienceName } from '@atlassian/notification-common';
import { AbortReason, ExperienceIds, Experiences } from '@atlassian/notification-common/types';
export var handleWithContentExperienceTracking = function handleWithContentExperienceTracking(notifications, experienceTracker) {
  var notificationsWithContent = notifications.filter(function (notification) {
    var _notification$content;
    return Boolean((_notification$content = notification.content.body) === null || _notification$content === void 0 || (_notification$content = _notification$content.items) === null || _notification$content === void 0 ? void 0 : _notification$content.length);
  });
  if (notificationsWithContent.length === 0) {
    experienceTracker.abort({
      name: Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT,
      reason: AbortReason.NO_DOCUMENTS
    });
    return;
  }
  var contentExperienceNames = notificationsWithContent.map(generateNotificationContentRenderExperienceName);

  // Create global experience to track each individual notification withContent
  experienceTracker.startWithDeps({
    name: Experiences.RENDER_NOTIFICATION_PAGE_WITH_CONTENT,
    id: ExperienceIds.FIRST_LOAD
  }, contentExperienceNames);

  // Create each individual notification withContent experience
  var _iterator = _createForOfIteratorHelper(contentExperienceNames),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var contentExperience = _step.value;
      experienceTracker.start({
        name: contentExperience.name,
        nameId: contentExperience.nameId,
        id: contentExperience.name
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};